<template>
    <div class="dashboard-view">
        <v-container>
            <v-row>
                <v-col cols="12">
                    <v-row dense>
                        <v-col cols="2">
                            <v-card flat tile class="blue-gradient">
                                <v-card-text>
                                    <p class="caption font-weight-bold primary--text">
                                        Total Trades
                                        <v-icon class="primary--text mx-2">currency_exchange</v-icon>
                                    </p>
                                    <p class="text--mono body-1 my-0 primary--text font-weight-bold ">{{ totalTrades }}
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="2">
                            <v-card flat tile class="blue-gradient">
                                <v-card-text>
                                    <p class="caption font-weight-bold primary--text">
                                        Total MMK
                                        <v-icon class="primary--text mx-2">attach_money</v-icon>
                                    </p>
                                    <p class="text--mono body-1 my-0 primary--text font-weight-bold">{{ totalMMK }}</p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="2">
                            <v-card flat tile class="blue-gradient">
                                <v-card-text>
                                    <p class="caption font-weight-bold primary--text">
                                        Total THB
                                        <v-icon class="primary--text mx-2">attach_money</v-icon>
                                    </p>
                                    <p class="text--mono body-1 my-0 font-weight-bold primary--text">{{ totalTHB }}</p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="2">
                            <v-card flat tile class="orange-gradient">
                                <v-card-text>
                                    <p class="caption font-weight-bold orange--text">
                                        Ongoing
                                        <v-icon class="orange--text mx-2">info</v-icon>
                                    </p>
                                    <p class="text--mono body-1 my-0 orange--text font-weight-bold">{{ onGoingCount }}
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="2">
                            <v-card flat tile class="green-gradient">
                                <v-card-text>
                                    <p class="caption font-weight-bold green--text">
                                        Success
                                        <v-icon class="green--text mx-2">check</v-icon>
                                    </p>
                                    <p class="text--mono body-1 my-0 font-weight-bold green--text">{{ successCount }}
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                        <v-col cols="2">
                            <v-card flat tile class="red-gradient">
                                <v-card-text>
                                    <p class="caption font-weight-bold red--text">
                                        Cancelled
                                        <v-icon class="red--text mx-2">attach_money</v-icon>
                                    </p>
                                    <p class="text--mono body-1 my-0 font-weight-bold red--text">{{ cancelledCount }}
                                    </p>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                    <v-divider class="my-4"></v-divider>
                    <v-row dense>
                        <v-col class="col-12 my-0 p-0" md="8">
                            <v-card tile flat class="mb-1">
                                <v-card-text>
                                    <v-row dense class="my-0">
                                        <v-menu ref="menu" v-model="menu" :close-on-content-click="false"
                                            :return-value.sync="date" transition="scale-transition" offset-y
                                            min-width="auto">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field v-model="date" label="Pick required date"
                                                    prepend-icon="mdi-calendar" readonly v-bind="attrs"
                                                    v-on="on"></v-text-field>
                                            </template>
                                            <v-date-picker v-model="date" no-title scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn text color="primary" @click="menu = false">
                                                    Cancel
                                                </v-btn>
                                                <v-btn text color="primary" @click="$refs.menu.save(date)">
                                                    OK
                                                </v-btn>
                                            </v-date-picker>
                                        </v-menu>

                                        <v-text-field label="Filter With Amount" prepend-icon="mdi-cash" readonly
                                            v-bind="attrs" v-on="on"></v-text-field>
                                    </v-row>
                                </v-card-text>
                            </v-card>
                            <v-simple-table>
                                <template v-slot:default>
                                    <thead>
                                        <tr>
                                            <th class="text-left">
                                                Date
                                            </th>
                                            <th class="text-left">
                                                Transfer By
                                            </th>
                                            <th class="text-left">
                                                From
                                            </th>
                                            <th class="text-left">
                                                Receive ACC
                                            </th>
                                            <th class="text-left">
                                                Owned
                                            </th>
                                            <th class="text-left">
                                                Amount (THB)
                                            </th>
                                            <th class="text-left">
                                                Status
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-if="trades.length == 0">
                                            <td>
                                                <p
                                                    class="number text--secondary blue--text font-weight-bold mt-4 caption my-0 mt-0">
                                                    No trade data for {{ date }}
                                                </p>
                                            </td>
                                        </tr>
                                        <tr v-for="item in trades" :key="item.name">
                                            <td>
                                                <p
                                                    class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4 caption my-0 mt-0">
                                                    {{ new Date(item.createdAt).toLocaleDateString() }}</p>
                                            </td>
                                            <td>
                                                <p
                                                    class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4 caption my-0 mt-0">
                                                    {{ item.transferBy.name }}</p>
                                            </td>
                                            <td>
                                                <p
                                                    class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4 caption my-0 mt-0">
                                                    {{ item.fromAccount.bankName }}</p>
                                            </td>
                                            <td>
                                                <p
                                                    class="number text--secondary blue--text font-weight-bold text-decoration-underline mt-4 caption my-0 mt-0">
                                                    {{ item.receiveAccount.bankName }}</p>
                                            </td>
                                            <td>
                                                <v-chip x-small dark :color="item.owned ? 'primary' : 'orange'">{{
                                                    item.owned ? "Owned" : "Not-Owned" }}</v-chip>
                                            </td>
                                            <td>
                                                <p
                                                    class="number text--secondary blue--text font-weight-medium font-mono mt-4 my-0 mt-0">
                                                    {{ item.amountTHB }}</p>
                                            </td>
                                            <td>
                                                <v-chip v-if="item.status == 'ongoing'" x-small dark color="orange"
                                                    class="my-0">Ongoing</v-chip>
                                                <v-chip v-if="item.status == 'success'" x-small dark color="green"
                                                    class="my-0">Success</v-chip>
                                                <v-chip v-if="item.status == 'cancelled'" x-small dark color="red"
                                                    class="my-0">Canceled</v-chip>
                                            </td>
                                        </tr>
                                    </tbody>
                                </template>
                            </v-simple-table>
                        </v-col>
                        <v-col cols="12" md="4">
                            <!-- <v-card flat tile>
                                <v-card-text>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        Trader Name
                                                    </th>
                                                    <th class="text-left">
                                                        Trade THB
                                                    </th>
                                                    <th class="text-left">
                                                        Profit USDT
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="my-0">
                                                    <td class="caption">KTB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold red--text caption">200</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card> -->
                            <v-card flat tile class="mt-2">
                                <v-card-text>
                                    <v-simple-table>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th class="text-left">
                                                        Bank Account
                                                    </th>
                                                    <th class="text-left">
                                                        Count
                                                    </th>
                                                    <th class="text-left">
                                                        Available Amount
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr class="my-0" v-for="account in bankAccounts" :key="account._id">
                                                    <td class="caption my-0">{{ account.bankAccount.bankName }}</td>
                                                    <td class="caption my-0">{{ account.usedCount }}</td>
                                                    <td class="caption my-0 font-weight-bold">{{ account.todayAvailableAmount }}</td>
                                                </tr>
                                                <!-- <tr class="my-0">
                                                    <td class="caption my-0">KTB</td>
                                                    <td class="caption my-0">10</td>
                                                    <td class="font-weight-bold red--text caption my-0">200</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption my-0">GSB</td>
                                                    <td class="caption my-0">10</td>
                                                    <td class="font-weight-bold green--text caption my-0">150,000</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr>
                                                <tr>
                                                    <td class="caption">GSB</td>
                                                    <td class="caption">10</td>
                                                    <td class="font-weight-bold green--text caption">150,000</td>
                                                </tr> -->
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { bankAccountStatusApi, tradeApi, traderApi } from "@/api";

export default {
    name: "DashboardPage",
    data: function () {
        return {
            loading: true,
            traderLoading: false,
            tradeLoading: false,
            page: 1,
            numberOfPages: null,
            trades: [],
            bankAccounts: [],
            itemsPerPage: 10,
            totalCount: null,
            options: {},
            headers: [
                { text: "Date", value: "createdAt" },
                { text: "Transfer By", value: "transferBy.name" },
                { text: "From", value: "fromAccount.bankName" },
                { text: "Receive ACC", value: "receiveAccount.bankName" },
                { text: "Owned", value: "owned" },
                { text: "Amount (THB)", value: "amountTHB" },
                { text: "Status", value: "status" },
            ],
            date: new Date().toISOString().split('T')[0],
            menu: false,
            modal: false,
            attrs: {},
            totalTrades: 0,
            totalMMK: 0,
            totalTHB: 0,
            successCount: 0,
            onGoingCount: 0,
            cancelledCount: 0
        };
    },
    created: function () {
        this.loadTraders();
        this.loadTodayTrades();
        this.loadBankAccountStatus();
    },
    watch: {
        date: async function () {
            this.loading = true
            try {
                const result = await tradeApi.getDailyReport(this.date);

                this.trades = result.trades;
                this.totalTrades = result.totalTrades
                this.totalMMK = result.totalAmountMMK
                this.totalTHB = result.totalAmountTHB

                this.successCount = result.statusCounts.success
                this.onGoingCount = result.statusCounts.ongoing
                this.cancelledCount = result.statusCounts.cancelled

                this.loadBankAccountStatus();
            } catch (error) {
                console.log(error);
            }
            this.loading = false;
        }
    },
    methods: {
        loadTodayTrades: async function () {
            this.loading = true;
            try {
                const result = await tradeApi.getDailyReport(this.date);

                this.trades = result.trades;
                this.totalTrades = result.totalTrades
                this.totalMMK = result.totalAmountMMK
                this.totalTHB = result.totalAmountTHB

                this.successCount = result.statusCounts.success
                this.onGoingCount = result.statusCounts.ongoing
                this.cancelledCount = result.statusCounts.cancelled
            } catch (error) {
                console.log(error);
            }

            this.loading = false;
        },
        loadTraders: async function () {
            this.traderLoading = true;
            try {
                const data = await traderApi.getTraders();
                console.log("data: ", data);

                this.traders = data.traders;
            } catch (error) {
                console.log(error);
            }
            this.traderLoading = false;
        },
        loadBankAccountStatus: async function () {
            try {
                const data = await bankAccountStatusApi.getDailyStatus(this.date)
                this.bankAccounts = data;
            } catch (error) {
                console.log(error);
            }
        }
    },
};
</script>
<style>
.blue-gradient {
    background-color: hsla(210, 24%, 84%, 1) !important;
}

.orange-gradient {
    background: rgb(255, 226, 184) !important;

}

.green-gradient {
    background: rgb(177, 218, 167) !important;
}

.red-gradient {
    background: rgb(253, 194, 194) !important;
}
</style>
